<template>
  <v-app id="inspire">
    <div class="info-page">

      <!-- ===== HERO FIXE ===== -->
      <div class="info-hero" :style="heroStyle">
        <div class="info-hero__bar">
          <div class="info-hero__left">    
            <div>
              <div class="info-hero__kicker">Demande d'adhésion</div>
              <div class="info-hero__title">{{ demandeAdhesion.raisonSociale || 'Chargement...' }}</div>
            </div>
          </div>
          <div class="info-hero__right">
            <v-btn
              small
              color="white"
              class="info-back-btn"
              elevation="0"
              @click="$router.go(-1)"
            >
              <v-icon left small color="#159e72">mdi-arrow-left</v-icon>
              <span style="color:#159e72;font-weight:700">Retour</span>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- ===== CONTENU ===== -->
      <div class="info-content">
        <v-container fluid>
          <v-row>
            <!-- Colonne principale -->
            <v-col cols="12" md="8">
              <!-- Informations générales -->
              <v-card class="info-card" elevation="0">
                <div class="info-card__header">
                  <div class="info-card__icon">
                    <v-icon size="18" color="#159e72">mdi-information</v-icon>
                  </div>
                  <span class="info-card__title">Informations générales</span>
                </div>
                <div class="info-card__body">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <div class="info-field__label">Raison sociale</div>
                        <div class="info-field__value">{{ demandeAdhesion.raisonSociale || '—' }}</div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <div class="info-field__label">Sigle</div>
                        <div class="info-field__value">{{ demandeAdhesion.sigle || '—' }}</div>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="info-field">
                        <div class="info-field__label">Description</div>
                        <div class="info-field__value">{{ demandeAdhesion.description || '—' }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>

              <!-- Contact -->
              <v-card class="info-card mt-4" elevation="0">
                <div class="info-card__header">
                  <div class="info-card__icon">
                    <v-icon size="18" color="#159e72">mdi-card-account-phone</v-icon>
                  </div>
                  <span class="info-card__title">Contact</span>
                </div>
                <div class="info-card__body">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <div class="info-field__label">E-mail</div>
                        <div class="info-field__value">
                          <v-icon size="14" color="#64748b" class="mr-1">mdi-email</v-icon>
                          {{ demandeAdhesion.email || '—' }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <div class="info-field__label">Téléphone</div>
                        <div class="info-field__value">
                          <v-icon size="14" color="#64748b" class="mr-1">mdi-phone</v-icon>
                          {{ demandeAdhesion.telephone || '—' }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <div class="info-field__label">Ville</div>
                        <div class="info-field__value">
                          <v-icon size="14" color="#64748b" class="mr-1">mdi-map-marker</v-icon>
                          {{ demandeAdhesion.villeDesignation || '—' }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>

              <!-- Documents -->
              <v-card class="info-card mt-4" elevation="0">
                <div class="info-card__header">
                  <div class="info-card__icon">
                    <v-icon size="18" color="#159e72">mdi-file-document-multiple</v-icon>
                  </div>
                  <span class="info-card__title">Documents rattachés</span>
                </div>
                <div class="info-card__body">
                  <v-row v-if="loadingDocuments">
                    <v-col cols="12">
                      <div class="text-center py-4">
                        <v-progress-circular indeterminate color="#159e72" size="32"></v-progress-circular>
                        <div class="mt-2 text-caption text--secondary">Chargement des documents...</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="documents.length === 0">
                    <v-col cols="12">
                      <div class="text-center py-4">
                        <v-icon size="48" color="#cbd5e1">mdi-file-document-outline</v-icon>
                        <div class="mt-2 text-body-2 text--secondary">Aucun document disponible</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col v-for="(doc, index) in documents" :key="index" cols="12" sm="6">
                      <div class="doc-item">
                        <div class="doc-item__icon">
                          <v-icon size="20" :color="getDocIconColor(doc.typeDocument)">{{ getDocIcon(doc.typeDocument) }}</v-icon>
                        </div>
                        <div class="doc-item__info">
                          <div class="doc-item__type">{{ getDocLabel(doc.typeDocument) }}</div>
                          <a v-if="doc.url" :href="doc.url" target="_blank" class="doc-item__link">
                            <v-icon size="12" class="mr-1">mdi-open-in-new</v-icon>
                            Voir le document
                          </a>
                          <div v-else class="doc-item__link doc-item__link--disabled">
                            Non disponible
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>

            <!-- Colonne latérale -->
            <v-col cols="12" md="4">
              <!-- Activité -->
              <v-card class="info-card" elevation="0">
                <div class="info-card__header">
                  <div class="info-card__icon">
                    <v-icon size="18" color="#159e72">mdi-clock-outline</v-icon>
                  </div>
                  <span class="info-card__title">Activité</span>
                </div>
                <div class="info-card__body">
                  <div class="info-field">
                    <div class="info-field__label">Compte créé le</div>
                    <div class="info-field__value">{{ createdAtLabel }}</div>
                  </div>
                </div>
              </v-card>

              <!-- Statut -->
              <v-card class="info-card mt-4" elevation="0">
                <div class="info-card__header">
                  <div class="info-card__icon">
                    <v-icon size="18" color="#159e72">mdi-shield-check</v-icon>
                  </div>
                  <span class="info-card__title">Statut</span>
                </div>
                <div class="info-card__body">
                  <div class="info-field mb-3">
                    <div class="info-field__label">Validation</div>
                    <div class="info-field__value">
                      <v-chip
                        x-small
                        :color="demandeAdhesion.isValidate ? 'success' : 'error'"
                        dark
                      >
                        {{ demandeAdhesion.isValidate ? 'Validé' : 'En attente' }}
                      </v-chip>
                    </div>
                  </div>
                  <div class="info-field">
                    <div class="info-field__label">Activation</div>
                    <div class="info-field__value">
                      <v-chip
                        x-small
                        :color="demandeAdhesion.isActif ? 'success' : 'error'"
                        dark
                      >
                        {{ demandeAdhesion.isActif ? 'Actif' : 'Inactif' }}
                      </v-chip>
                    </div>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <v-btn
                    v-if="canActivate"
                    block
                    color="#159e72"
                    dark
                    small
                    @click="validerDemandeAdhesion"
                    class="info-action-btn"
                  >
                    <v-icon small left>mdi-check</v-icon>
                    Activer la compagnie
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import axios from "axios";
import { API_OBTENIR_LISTE_DE_TOUTES_LES_DEMANDES_ADHESIONS, API_VALIDER_DEMANDE_ADHESION_COMPAGNIE, API_GET_DOCUMENT_URL, HEADERS  } from "@/components/globalConfig/globalConstConfig"
import { showErrorMessage } from "@/modules/messages/messageProcess";
export default {
    name:"InfosAdhesion",
    data(){
        return{
            demandeAdhesion: {},
            loading: true,
            loadingDocuments: false,
            errorMsg: "",
            documents: [],
            
            toValid:{
                data:{
                    id : null,
                }
            },

            demandeAdhesionList:[],

            options:{
                index:0,
                size:8
            },

            attestationDocumentObject: {
                data: {
                    typeDocument: "",
                    compagnieTransportRaisonSociale: ""
                }
            },

            logoDocumentObject: {
                data: {
                    typeDocument: "",
                    compagnieTransportRaisonSociale: ""
                }
            },
        }
    },

    computed: {
        heroStyle() {
            return {
                top: this.$vuetify.application.top + "px",
                left: this.$vuetify.application.left + "px",
                right: this.$vuetify.application.right + "px",
            };
        },
        canActivate() {
            return this.demandeAdhesion && this.demandeAdhesion.isActif === false;
        },
        createdAtLabel() {
            const raw = this.demandeAdhesion ? this.demandeAdhesion.createdAt : null;
            if (!raw) return "—";
            const d = new Date(raw);
            if (Number.isNaN(d.getTime())) return String(raw);
            return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        },
    },

    methods:{

        async validerDemandeAdhesion(){
            this.toValid.data.id = this.demandeAdhesion.id
            await axios.post(API_VALIDER_DEMANDE_ADHESION_COMPAGNIE, this.toValid , { headers : HEADERS(this.$store.state.userAuthentified.token) }).then((response) => {
                if (response.status == 200) {
                    if (response.data.status.code != 800) {
                        this.$swal.fire('Validation',response.data.status.message,'error')
                        this.toValid.data.id = null;
                    }
                    else{
                        this.$swal.fire('Validation',response.data.status.message,'success')
                        this.toValid.data.id = null;
                        this.demandeAdhesion.isActif = true
                    }
                }
                else{
                    this.$swal.fire('Validation','Error lors de la validation','error')
                    this.toValid.data.id = null;
                }
            }).catch((e) => {
                this.$swal.fire('Validation refusée' , e , 'error')
                this.toValid.data.id = null;
            })
        },


        //OBTENIR LA LISTE DE TOUTES LES DEMANDE D'ADHESIONS EFFECTUÉS
        async obtenirToutesLesDemandesAdhesion(){
            this.loading = true;
            axios.post(API_OBTENIR_LISTE_DE_TOUTES_LES_DEMANDES_ADHESIONS , this.options, { headers : HEADERS(this.$store.state.userAuthentified.token) }).then((response) => {
                if (response.status == 200) {
                    if (response.data.status.code != 800) {
                        this.errorMsg = response.data.status.message
                        showErrorMessage()
                    }else{
                        this.demandeAdhesionList = response.data.items;
                        this.demandeAdhesionList.forEach(element => {
                            if (element.raisonSociale == this.$route.params.raisonSociale) {
                                this.demandeAdhesion = element ;
                            }
                        });
                        // Récupérer les documents après avoir trouvé la demande
                        if (this.demandeAdhesion && this.demandeAdhesion.id) {
                            this.getDocuments();
                        }
                    }
                }else{
                    this.errorMsg = "Erreur";
                }
            }).catch((e) => {
                this.errorMsg = e
            }).finally(() => {
                this.loading = false;
            })
        },

        // Récupérer les documents rattachés
        async getDocuments() {
            this.loadingDocuments = true;
            this.documents = [];
            
            try {
                // Récupérer l'attestation de transport
                await this.getUrlAttestationDocument();
                
                // Récupérer le logo
                await this.getUrlLogoCompagnie();
                
            } catch (error) {
                console.error('Erreur lors de la récupération des documents:', error);
            } finally {
                this.loadingDocuments = false;
            }
        },

        // Récupérer l'URL de l'attestation de transport
        async getUrlAttestationDocument() {
            this.attestationDocumentObject.data.typeDocument = "ATTESTATION_TRANSPORT";
            this.attestationDocumentObject.data.compagnieTransportRaisonSociale = this.demandeAdhesion.raisonSociale;
                        
            try {
                const response = await axios.post(
                    API_GET_DOCUMENT_URL,
                    this.attestationDocumentObject,
                    { headers: HEADERS(this.$store.state.userAuthentified.token) }
                );
                
                
                if (response.data.status.code == 800) {
                    this.documents.push({
                        typeDocument: 'ATTESTATION_TRANSPORT',
                        url: response.data.item.url
                    });
                } else {
                    console.log('⚠️ Attestation non trouvée:', response.data.status.message);
                }
            } catch (error) {
                console.error('❌ Erreur attestation:', error);
            }
        },

        // Récupérer l'URL du logo
        async getUrlLogoCompagnie() {
            this.logoDocumentObject.data.typeDocument = "LOGO";
            this.logoDocumentObject.data.compagnieTransportRaisonSociale = this.demandeAdhesion.raisonSociale;
                        
            try {
                const response = await axios.post(
                    API_GET_DOCUMENT_URL,
                    this.logoDocumentObject,
                    { headers: HEADERS(this.$store.state.userAuthentified.token) }
                );
                                
                if (response.data.status.code == 800) {
                    this.documents.push({
                        typeDocument: 'LOGO',
                        url: response.data.item.url
                    });
                } else {
                    console.log('⚠️ Logo non trouvé:', response.data.status.message);
                }
            } catch (error) {
                console.error('❌ Erreur logo:', error);
            }
        },

        // Obtenir l'icône selon le type de document
        getDocIcon(typeDocument) {
            const icons = {
                'ATTESTATION_TRANSPORT': 'mdi-file-certificate',
                'LOGO': 'mdi-image',
                'PHOTO_PROFIL': 'mdi-account-circle',
                'DOCUMENT_IDENTITE': 'mdi-card-account-details',
                'REGISTRE_COMMERCE': 'mdi-file-document',
                'AUTRE_DOCUMENT': 'mdi-file'
            };
            return icons[typeDocument] || 'mdi-file';
        },

        // Obtenir la couleur de l'icône selon le type
        getDocIconColor(typeDocument) {
            const colors = {
                'ATTESTATION_TRANSPORT': '#10b981',
                'LOGO': '#f59e0b',
                'PHOTO_PROFIL': '#3b82f6',
                'DOCUMENT_IDENTITE': '#8b5cf6',
                'REGISTRE_COMMERCE': '#f59e0b',
                'AUTRE_DOCUMENT': '#64748b'
            };
            return colors[typeDocument] || '#64748b';
        },

        // Obtenir le label selon le type
        getDocLabel(typeDocument) {
            const labels = {
                'ATTESTATION_TRANSPORT': 'Attestation de transport',
                'LOGO': 'Logo de la compagnie',
                'PHOTO_PROFIL': 'Photo de profil',
                'DOCUMENT_IDENTITE': 'Pièce d\'identité',
                'REGISTRE_COMMERCE': 'Registre de commerce',
                'AUTRE_DOCUMENT': 'Autre document'
            };
            return labels[typeDocument] || typeDocument;
        },
    },

    mounted(){
        this.obtenirToutesLesDemandesAdhesion();
    }
}
</script>

<style scoped>
:deep(*) { font-family: "Montserrat" !important; }

#inspire { background: #f8fafc; min-height: 100vh; }
.info-page { min-height: 100%; }

/* ===== HERO FIXE ===== */
.info-hero {
  position: fixed;
  z-index: 5;
  box-shadow: 0 2px 12px rgba(21, 158, 114, 0.18);
}
.info-hero__bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  background: linear-gradient(to right, #159e72 0%, #1e3a8a 100%);
  color: white;
}
.info-hero__left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.info-hero__kicker {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.85;
  margin-bottom: 3px;
}
.info-hero__title {
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}
.info-hero__right {
  flex-shrink: 0;
}
.info-back-btn {
  border-radius: 10px !important;
  text-transform: none !important;
}

/* ===== CONTENT ===== */
.info-content {
  padding: 60px 0 40px;
}

/* ===== CARDS ===== */
.info-card {
  border-radius: 16px !important;
  border: 1.5px solid #f1f5f9 !important;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04) !important;
}
.info-card__header {
  padding: 14px 18px;
  background: rgba(21,158,114,0.03);
  border-bottom: 1.5px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 10px;
}
.info-card__icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
.info-card__title {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}
.info-card__body {
  padding: 20px;
}

/* ===== FIELDS ===== */
.info-field {
  margin-bottom: 16px;
}
.info-field:last-child {
  margin-bottom: 0;
}
.info-field__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  margin-bottom: 6px;
}
.info-field__value {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
}

/* ===== DOCUMENTS ===== */
.doc-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  border: 1.5px solid #f1f5f9;
  background: white;
  transition: all 0.2s ease;
}
.doc-item:hover {
  border-color: #e2e8f0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.doc-item__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.doc-item__info {
  flex: 1;
  min-width: 0;
}
.doc-item__type {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}
.doc-item__link {
  font-size: 12px;
  font-weight: 600;
  color: #159e72;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s ease;
}
.doc-item__link:hover {
  color: #0f766e;
  text-decoration: underline;
}
.doc-item__link--disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

/* ===== BUTTON ===== */
.info-action-btn {
  font-weight: 700 !important;
  text-transform: none !important;
  border-radius: 10px !important;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .info-hero__bar {
    padding: 12px 16px;
  }
  .info-hero__title {
    font-size: 16px;
  }
  .info-hero__right {
    display: none;
  }
}
</style>